import 'babel-polyfill'
import Vue from 'vue'
import Bootstrap from './Bootstrap'
import './plugins/frontend/plugins'

// Sets app environment to false
Vue.config.productionTip = true

// Inits vue app
new Vue({
  render: h => h(Bootstrap),
}).$mount('#xit-flow-builder')
